import { useMemo, useState } from 'react';
import { fetchGerencialSerie } from '@/services/gerencial.js';

const csv = (rows) => {
  if (!rows.length) return '';
  const h = Object.keys(rows[0]);
  return [h.join(','), ...rows.map((r) => h.map((k) => JSON.stringify(r[k] ?? '')).join(','))].join('\n');
};

export default function GerencialReportesPage() {
  const [filters, setFilters] = useState({ desde: '', hasta: '', sucursalId: '', lineaId: '' });
  const [rows, setRows] = useState([]);
  const totalGuias = useMemo(() => rows.reduce((acc, item) => acc + Number(item.guias || 0), 0), [rows]);

  return (
    <div className="mx-auto w-full max-w-[1400px] px-6 py-6 text-[rgb(var(--fg))]">
      <h1 className="text-2xl font-semibold">Gerencial / Reportes</h1>
      <div className="mt-4 grid grid-cols-12 gap-3 rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.9)] p-4">
        <input type="date" className="col-span-12 rounded-xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 md:col-span-3" value={filters.desde} onChange={(e) => setFilters({ ...filters, desde: e.target.value })} />
        <input type="date" className="col-span-12 rounded-xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 md:col-span-3" value={filters.hasta} onChange={(e) => setFilters({ ...filters, hasta: e.target.value })} />
        <button className="col-span-6 rounded-xl bg-[rgb(var(--brand))] px-3 py-2 text-white md:col-span-2" onClick={async () => setRows(await fetchGerencialSerie({ ...filters, granularidad: 'dia' }))}>Consultar</button>
        <button className="col-span-6 rounded-xl border border-[rgba(var(--border),0.7)] px-3 py-2 md:col-span-2" onClick={() => {
          const blob = new Blob([csv(rows)], { type: 'text/csv;charset=utf-8;' });
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'gerencial_reporte.csv';
          a.click();
        }}>Export CSV</button>
      </div>
      <div className="mt-4 rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.9)] p-4">Total guías: {totalGuias}</div>
      <div className="mt-4 overflow-auto rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.9)] p-3">
        <table className="w-full text-sm"><thead><tr><th>Fecha</th><th>Guías</th><th>Entregadas</th><th>Retenidas</th><th>Flete</th><th>CR</th><th>Margen Est.</th><th>Margen Real</th></tr></thead><tbody>
          {rows.map((row) => <tr key={row.fecha} className="border-t border-[rgba(var(--border),0.5)]"><td>{row.fecha}</td><td>{row.guias}</td><td>{row.entregadas}</td><td>{row.retenidas}</td><td>{row.flete}</td><td>{row.cr}</td><td>{row.margenEstimado}</td><td>{row.margenReal}</td></tr>)}
        </tbody></table>
      </div>
    </div>
  );
}
